// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"dd954b14","703":"bc613f86","787":"8bc74567"}[chunkId] + ".chunk.js";
};